import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";
import VueAgile from "vue-agile";
import VueAwesomeSwiper from "vue-awesome-swiper";

//vue-meta are applied asynchronously, that take some time
import Meta from "vue-meta";
Vue.use(Meta);

import "swiper/dist/css/swiper.css";

Vue.use(VueAgile);
Vue.use(VueAwesomeSwiper);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");
